import { transition, trigger } from '@angular/animations';

export const noInitialAnimation = () => {
	return trigger('noInitialAnimation', [transition(':enter', [])]);
};
